module.exports = __webpack_public_path__ + "9e69f6b1eec3b4c75d7f6d9e54eb33a5.svg";